// ==============================|| OVERRIDES - PAPER ||============================== //

export default function Paper() {
	return {
		MuiPaper: {
			styleOverrides: {
				boxShadow: "none!important",
			},
			root: {
				boxShadow: "none!important",
			},
			tableContainer: {
				boxShadow: "none!important",
			},
		},
	};
}
